import { TruckIcon, GiftIcon, LeafIcon, MessageCircleIcon } from 'lucide-react';
import { founder } from '../../data/content';
import { useSite } from '../../contexts/SiteContext';
import { giftsBesidesShipping } from '../../data/gifts';
import { freeShippingLine } from '../../data/policies';
import { euro } from '../../core/format/currency';
import type { SiteSettings } from '../../core/types/site';

/** Altijd uit de actuele instellingen (useSite), zodat een andere staffel hier vanzelf klopt. */
function badges(site: SiteSettings) {
  const gifts = giftsBesidesShipping(site.giftTiers, site.policy.freeShippingFrom);
  const giftLine = gifts.map(t => `${t.title.toLowerCase()} vanaf ${euro(t.threshold)}`).join(' · ').replace(/^./, c => c.toUpperCase());
  return [{
    icon: TruckIcon,
    label: freeShippingLine(site.policy.freeShippingFrom)
  }, ...(giftLine ? [{
    icon: GiftIcon,
    label: giftLine
  }] : []), {
    icon: LeafIcon,
    label: '100% vegan, boom per product'
  }, {
    icon: MessageCircleIcon,
    label: `Gratis persoonlijk advies van ${founder.firstName}`
  }];
}

/**
 * Vier beloftes in één rustige regel. Staat onderaan het lichte collectievlak (geen eigen vlak):
 * een haarlijn erboven scheidt ze van de producten.
 */
export function TrustBadges() {
  const site = useSite();
  return <section aria-label="Bij elke bestelling" className="border-t border-line" data-id="element-9095" data-mp="ze2744p56qiw">
      <ul className="grid gap-x-8 gap-y-4 pt-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-9096" data-mp="1n46acayf4o9d">
        {badges(site).map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-3" data-id="element-9097" data-mp="1s27smto0sjjs">
            <Icon className="h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-9098" data-mp="1d607nr4sfe3g" />
            <span className="text-[14px] leading-snug text-muted" data-id="element-9099" data-mp="1i532yjuyu5y8">{label}</span>
          </li>)}
      </ul>
    </section>;
}